import React from 'react';
import { Tooltip } from 'recharts';
import { Card, Badge } from 'antd';
import { Formatter } from '../../../utils';
import './styles.scoped.css';

function renderTooltip(props: any) {
  return (
    <Card title={props.label} size="small">
      {props.payload?.map((item: any) => (
        <div className="tooltip-item" key={item.name}>
          <Badge
            text={Formatter.startCaseWithSpecialChars(item.name)}
            color={item.color || item.payload.fill || '#000'}
          />
          <div className="separator" />
          <div className="value">{Formatter.count(item.value)}</div>
        </div>
      ))}
    </Card>
  );
}

function CustomTooltip() {
  return <Tooltip content={renderTooltip} />;
}

export default CustomTooltip;
